module.exports = __webpack_public_path__ + "img/una-seguros.c215bdec.png";